import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NlvApproved from "./pages/NlvApproved";
import EuApproved from "./pages/EuApproved";
import Masterclass from "./pages/Masterclass";
import Tools from "./pages/Tools";
import Quiz from "./pages/Quiz";
import EuReadiness from "./pages/EuReadiness";
import About from "./pages/About";
import ClientSuccess from "./pages/ClientSuccess";
import Checklist from "./pages/Checklist";
import Calculator from "./pages/Calculator";
import Admin from "./pages/Admin";
import { Toaster } from "@/components/ui/sonner";
import AppTracking from "@/components/site/AppTracking";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppTracking />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nlv-approved" element={<NlvApproved />} />
          <Route path="/eu-approved" element={<EuApproved />} />
          <Route path="/masterclass" element={<Masterclass />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/eu-readiness" element={<EuReadiness />} />
          <Route path="/about" element={<About />} />
          <Route path="/client-success" element={<ClientSuccess />} />
          <Route path="/checklist" element={<Checklist />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
